import JsonLd from '@/components/base/JsonLd';
import { websiteSchema, organizationSchema, faqSchema } from '@/lib/schema';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import Features from './components/Features';
import WhatIsSection from './components/WhatIsSection';
import Comparison from './components/Comparison';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <ArticleCards />
        <Features />
        <WhatIsSection />
        <Comparison />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}